import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import logger from 'redux-logger';
import { PersistPartial, persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { IRootState, rootReducer } from '../Reducers/RootReducer';

const middlewares: any[] = [];

if (process.env.NODE_ENV === `development`) {
  middlewares.push(logger);
}

const persistConfig = {
  key: 'root',
  storage
};

const persistedReducer = persistReducer<IRootState, any>(persistConfig, rootReducer);

export default () => {
  const store =
    process.env.NODE_ENV === `development`
      ? createStore<IRootState & PersistPartial, any, any, any>(persistedReducer, composeWithDevTools(applyMiddleware(...middlewares)))
      : createStore<IRootState & PersistPartial, any, any, any>(persistedReducer);

  const persistor = persistStore(store);
  return { store, persistor };
};
